// Session Storage Keys for GEO filters
export const GEO_SELECTED_REGION = 'GEO_SELECTED_REGION';
export const GEO_SELECTED_STATES = 'GEO_SELECTED_STATES';
export const GEO_SELECTED_MARKET = 'GEO_SELECTED_MARKET';
export const GEO_SELECTED_TINS = 'GEO_SELECTED_TINS';
export const SESSION_STATE_KEY = 'state';
export const SESSION_MULTI_TINS_KEY = 'multiSelectedTins';
